module.exports = "<p>\n  user-list works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/admin-customers/user-list/user-list.component.html
// module id = ./src/app/components/admin/admin-customers/user-list/user-list.component.html
// module chunks = main